export default {
    url: '',
    template: `
            <div class="heading01 type01">
                <h1>{{ 'user.Manage users' | translate }}</h1>
            </div>
            <ul class="tabs01">
                <li>
                    <a ui-sref="authorized.manage.permissions.users.list.tms()" ui-sref-opts="{ location: 'replace' }"
                    ng-class="{ active: vm.$state.includes('authorized.manage.permissions.users.list.tms') }">
                        {{ 'user.TMS users' | translate }}
                    </a>
                </li>
                <li>
                    <a ui-sref="authorized.manage.permissions.users.list.all()" ui-sref-opts="{ location: 'replace' }"
                    ng-class="{ active: vm.$state.includes('authorized.manage.permissions.users.list.all') }">
                        {{ 'user.Employee Portal users' | translate }}
                    </a>
                </li>
            </ul>
            <ui-view></ui-view>
    `,
    abstract: true,
    controller ($state) {
        this.$state = $state;
    }
};




// WEBPACK FOOTER //
// ./src/app/states/authorized/manage/permissions/users/list/index.js